class HowToMeasurePanel extends Panel {
  constructor() {
    super();
    this.defaultFocus = this.querySelector("[aria-selected='true']");
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    //super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    requestAnimationFrame(() => {
      if (previousState === 'idle') {
        actions.openRightBottomNav().then(() => {
          window.trapFocus(this, this.defaultFocus, triggerElement);
        });
      } else if (previousPanel) {
        window.trapFocus(this, this.defaultFocus, triggerElement);
        previousPanel.deactivate(['addToCartSizeActive', 'productDetailsActive'].indexOf(previousState) > -1);
      }
    });
  }
}
customElements.define('how-to-measure-panel', HowToMeasurePanel);
